// Filters of the analysis screens applied to objections.
//
// Objection documents (models/objection.js) store `store` (the store's display name when the objection was made), `mainStoreId` (the LUD store code),
// `branch` (branch display name) and `app`. They have no `storeName` / `branchName`, which the screens compare for report rows, so comparing those
// names against objections dropped every objection as soon as a store or branch filter was set.
import { normalizeIntegrationKey } from "./integrations";

const appKeyOf = (value) => normalizeIntegrationKey(value) || value;
const text = (value) => String(value ?? "").trim();

// stores: [{ id, businessName }] the caller may analyse. A store is matched by its code first (a renamed store still matches), else by the saved name.
export function objectionMatchesFilters(item, filters, stores = []) {
  if (filters.app.length && !filters.app.includes(appKeyOf(item.app))) return false;
  if (filters.store.length) {
    const byCode = stores.find((store) => String(store.id) === String(item.mainStoreId));
    const name = byCode ? byCode.businessName : item.store;
    if (!filters.store.includes(name) && !filters.store.includes(item.store)) return false;
  }
  if (filters.branch.length && !filters.branch.includes(text(item.branch))) return false;
  return true;
}
